import { z } from 'zod';
import { isWholeQuantity } from '../../utils/is-whole-quantity.js';
import { WHOLE_QUANTITY_MESSAGE } from '../quantity/whole-quantity-message.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { rmaReturnQtySchema } from './rma-return-qty.js';
import { rmaReturnReasonSchema } from './rma-return-reason.js';
const QTY_MESSAGE = 'Enter a quantity to return of 0 or more.';
const isReturned = (qty) => Number.isFinite(qty) && qty > 0;
const rowSchema = z
    .object({
    salesOrderItemId: requiredUuidString('Line is required.', 'Invalid line selection.'),
    /** Shipped minus already returned (RMA-5). */
    qtyReturnable: z.number(),
    /** The line's or its part's unit is counted in whole pieces. */
    qtyIsIntegral: z.boolean(),
    /** NaN or 0 while the line isn't being returned. */
    qty: z.number().or(z.nan()),
    reason: z.string(),
})
    .superRefine((row, context) => {
    const issue = (path, message) => context.addIssue({ code: 'custom', path: [path], message });
    if (row.qty < 0)
        return issue('qty', QTY_MESSAGE);
    if (!isReturned(row.qty))
        return;
    // The API's own quantity rule (decimals, upper bound).
    const qtyMessage = rmaReturnQtySchema.safeParse(row.qty).error?.issues[0]?.message;
    if (qtyMessage)
        issue('qty', qtyMessage);
    if (row.qtyIsIntegral && !isWholeQuantity(row.qty))
        issue('qty', WHOLE_QUANTITY_MESSAGE);
    // The API's own over-return copy, so the dialog and a refused create read alike.
    if (row.qty > row.qtyReturnable)
        issue('qty', `Only ${row.qtyReturnable} can still be returned.`);
    const reason = rmaReturnReasonSchema.safeParse(row.reason).error?.issues[0]?.message;
    if (reason)
        issue('reason', reason);
});
/** The Create RMA dialog: one row per stocked line of the original (RMA-5). */
export const createRmaFormSchema = z.object({
    lines: z
        .array(rowSchema)
        .refine((rows) => rows.some((row) => isReturned(row.qty)), 'Choose at least one line to return.'),
});
//# sourceMappingURL=create-rma-form.js.map